<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title">
        <appl-menu-icon
          :propsParam="{
            applCd: GET_SEARCH_APPL_CD,
            gntGubunCd: GET_GNT_GUBUN_CD,
          }"
        ></appl-menu-icon>
        근태휴가를 선택해주세요.
      </v-col>
    </v-row>
    <v-list>
      <v-list-item-group color="primary">
        <v-list-item
          v-for="(item, i) in menuList"
          :key="i"
          class="gntType-item"
        >
          <v-list-item-content @click="selectMenu(item)">
            <!-- 근태 -->
            <v-list-item-title v-text="item.codeNm" />
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>

  </div>
</template>
<script>
import ApplMenuIcon from '@/components/application/form/ApplMenuIcon.vue';


import { mapGetters, mapMutations } from 'vuex';

import routerNames from '@/const/routerConstants';
import { getVacationAppDetGntGubunList, getGenderNm } from '@/api/workStatus';

import dayjs from 'dayjs';
/**  */
export default {
  data: () => ({
    menuList: [],

  }),
  computed: {
    ...mapGetters('CODE', ['GET_GNT_CD_LIST', 'GET_GNT_CD_OBJ']),
    ...mapGetters('ELA', [
      'GET_GNT_GUBUN_CD',
      'GET_SEARCH_APPL_CD',
      'GET_GNT_CD',
      'GET_VACATION_PARAM',
    ]),

  },

  methods: {
    ...mapMutations('ELA', [
      'SET_GNT_GUBUN_CD',
      'SET_ALTER_VACATION',
      'SET_APP_MENU',
      'SET_S_YMD',
      'SET_E_YMD',
      'SET_HOL_WORK_YMD',
      'SET_GNT_CD',
      'SET_HALF_YN',
    ]),
    ...mapMutations('CODE', ['SET_GNT_CODE_TMP']),
    ...mapMutations('SPINNER', ['ON_APP_SPINNER', 'OFF_APP_SPINNER']),

    /* 신청서 선택 */
    async selectMenu(menu) {

      // console.log('menu ::: '+JSON.stringify(menu));

      if (menu.code === '17') {
        let param = {};

        let res = await getGenderNm(param);

        if (res.data.data.genderNm === '남성') {
          alert('신청할수 없는 신청서 입니다');
          return;
        }
      }

      this.$store.commit('SET_VACATION_GNT_GUBUN_MENU', menu);
      this.$router.push(routerNames.VacationView);
    },
  },

  async mounted() {
    this.ON_APP_SPINNER(); // 스피너 ON

    let response = await getVacationAppDetGntGubunList();
    this.menuList = response.data.data;

    this.$store.commit('SET_PARAMS', []);
    this.$store.commit('SET_GNT', []);
    this.$store.commit('SET_FILE_SEQ', '');

    this.OFF_APP_SPINNER();
  },
  components: {
    ApplMenuIcon,

  },
};
</script>
<style>
.row.title-wrap {
  margin-bottom: 10px;
}
.chip-wrap {
  padding: 0px 22px 20px;
}
.gntType-item {
  padding-left: 54px;
  padding-right: 54px;
}
.divider::before {
  margin: 0 10px;
}
</style>
